<script lang="ts" setup>
// @ts-ignore
import {Splide} from '@splidejs/vue-splide';
import {isDesktop} from "@/helpers/breakpointHelpers";
import {onBeforeUnmount, onMounted, ref} from "vue";

const options = {
  perPage: 2,
  gap: 20,
  pagination: false,
  arrowPath: 'M 39.746094 6.382812 C 40.085938 6.722656 40.085938 7.277344 39.746094 7.617188 L 34.210938 13.1875 C 33.871094 13.527344 33.320312 13.527344 32.980469 13.1875 C 32.640625 12.84375 32.640625 12.292969 32.980469 11.949219 L 37.902344 7 L 32.980469 2.050781 C 32.640625 1.707031 32.640625 1.15625 32.980469 0.8125 C 33.320312 0.472656 33.871094 0.472656 34.210938 0.8125 Z M 0 6.125 L 39.128906 6.125 L 39.128906 7.875 L 0 7.875 Z M 0 6.125 '
}

const isMobile = ref(!isDesktop())

const resizeHandler = (): void => {
  isMobile.value = !isDesktop()
}

onMounted(() => {
  window.addEventListener('resize', resizeHandler)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', resizeHandler)
})
</script>

<template>
  <Splide v-if="!isMobile" :options="options" class="splide">
    <slot/>
  </Splide>
  <template v-else>
    <slot/>
  </template>
</template>

<style lang="scss" scoped>
.splide {
  :deep(.splide__arrows) {
    @apply absolute -bottom-9 bg-red-100 left-1/2 flex-row-reverse flex;
  }

  :deep(.splide__arrow) {
    @apply bg-transparent translate-y-0 w-auto transition-colors;
  }

  :deep(.splide__arrow:hover) {
    @apply text-blue-600;
  }

  :deep(.splide__arrow svg) {
    @apply size-auto;
  }

  :deep(.splide__arrow--next) {
    @apply -right-14;
  }

  :deep(.splide__arrow--prev) {
    @apply -left-14;
  }
}
</style>